import { BadgeIcon } from "./BadgeIcon";
import { BadgeRoot } from "./BadgeRoot";
import { BadgeText } from "./BadgeText";

export const Badge = {
  Root: BadgeRoot,
  Text: BadgeText,
  Icon: BadgeIcon,
};
